import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import apiClient from "../apiClient";
import { Link } from "react-router-dom";



const TransactionTypes = () => {
    const [transactiontypes, setTransactionTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect (() => {
        const fetchAllTransactionTypes = async () => {
            try {
                const res = await apiClient.get("/transactiontypes");
                setTransactionTypes(res.data);
            } catch (err) {
                setError("Failed to load transaction types.");
            } finally {
                setLoading(false);
            }
        };
        fetchAllTransactionTypes();
    }, []);

    const handleDelete = async (TransactionTypeID) => {
        try {
          await apiClient.delete(`/transactiontypes/${TransactionTypeID}`);
          setTransactionTypes((prev) => prev.filter((item) => item.TransactionTypeID !== TransactionTypeID));
        } catch (err) {
          setError("Delete failed. Please try again.");
        }
      };

    return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Transaction Types</h1>
          <p className="page-subtitle"><Link to="/">Home</Link> / Transaction Types</p>
        </div>
        <Link className="btn-link" to="/TransactionTypesAdd">Add Type</Link>
      </header>

      {error && <p className="notice notice-error">{error}</p>}
      {loading && <p className="notice notice-muted">Loading transaction types...</p>}

      {!loading && (
        <section className="resource-list">
          {transactiontypes.length === 0 ? (
            <p className="notice notice-muted">No transaction types yet.</p>
          ) : (
            transactiontypes.map((transactiontype) => (
              <article key={transactiontype.TransactionTypeID} className="resource-row">
                <div><strong>{transactiontype.Description}</strong></div>
                <div className="actions">
                  <button className="btn btn-danger" onClick={() => handleDelete(transactiontype.TransactionTypeID)}>Delete</button>
                  <Link className="btn-link" to={`/TransactionTypesUpdate/${transactiontype.TransactionTypeID}`}>Update</Link>
                </div>
              </article>
            ))
          )}
        </section>
      )}
    </div>
    );
};

export default TransactionTypes;
